import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=c7af52ec&scoped=true&lang=pug"
import script from "./add-or-update.vue?vue&type=script&lang=js"
export * from "./add-or-update.vue?vue&type=script&lang=js"
import style0 from "./add-or-update.vue?vue&type=style&index=0&id=c7af52ec&prod&scoped=true&lang=css"
import style1 from "./add-or-update.vue?vue&type=style&index=1&id=c7af52ec&prod&lang=css"
import style2 from "./add-or-update.vue?vue&type=style&index=2&id=c7af52ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7af52ec",
  null
  
)

export default component.exports